export type UserLike = { role?: string } | null | undefined;

export const isAdmin = (user: UserLike): boolean => {
  return !!user && typeof user.role === 'string' && user.role.toLowerCase() === 'admin';
};

export const isOmbudsman = (user: UserLike): boolean => {
  return !!user && typeof user.role === 'string' &&
    (user.role.toLowerCase() === 'ombudsman' ||
     user.role.toLowerCase() === 'fos_analyst' ||
     user.role.toLowerCase() === 'admin');
};

export const ADMIN_REDIRECT_PATH = '/v4/records';
export const OMBUDSMAN_REDIRECT_PATH = '/v4/today';

